import { useState } from 'react'
import {
  LuBolt,
  LuCodesandbox,
  LuInfo,
  LuLocate,
  LuMapPin,
  LuNavigation2,
  LuNavigation2Off,
  LuTriangleAlert,
  LuX,
} from 'react-icons/lu'

import {
  GEO_FEATURE_MARKER_COLOR,
  HIGH_RISK_MARKER_COLOR,
  SEARCH_MARKER_COLOR,
  useMarkerColors,
} from '@/feature/observatory'
import { MapEmbedding } from '@/feature/map'
import { useSettings } from '@/feature/organizations/api/useSettings'

import { MarkerBadge } from '@/components/MarkerBadge'

import styles from './MapIconLegend.module.css'

export const MapIconLegend = () => {
  const [showLegend, setShowLegend] = useState(false)
  const markerColors = useMarkerColors()
  const { data: settings } = useSettings()

  const hasOfflineTimeoutConfigured = settings?.vehicleOfflineAfter != null
  const lostColor = hasOfflineTimeoutConfigured
    ? (markerColors.lostContactAfterOfflineTimeout ?? markerColors.lostContactDefault)
    : markerColors.lostContactDefault

  return (
    <MapEmbedding
      position={window.google.maps.ControlPosition.RIGHT_TOP}
      className={styles.mapContainer}
    >
      <button type="button" className={styles.mapButton} onClick={() => setShowLegend(!showLegend)}>
        {!showLegend && <LuInfo size={24} strokeWidth={1.6} />}
        {showLegend && <LuX size={24} strokeWidth={1.5} />}
      </button>
      {showLegend && (
        <div className={styles.layerToggles}>
          <h4 className={styles.toggleTile}>Legend</h4>
          <div className={styles.content}>
            <div className={styles.legendContainer}>
              <MarkerBadge
                glyph={LuNavigation2}
                shape="pin"
                size={24}
                rotate={0}
                color={markerColors.moving}
                filled
              />
              <span>Asset Moving</span>
            </div>
            <div className={styles.legendContainer}>
              <MarkerBadge
                glyph={LuNavigation2}
                shape="pin"
                size={24}
                rotate={15}
                color={markerColors.stationary}
                filled
              />
              <span>Asset Stopped</span>
            </div>
            <div className={styles.legendContainer}>
              <MarkerBadge glyph={LuNavigation2Off} shape="pin" size={24} color={lostColor} />
              <span>Asset Lost Contact</span>
            </div>
            <div className={styles.legendContainer}>
              <MarkerBadge
                glyph={LuCodesandbox}
                shape="pin"
                size={24}
                color={markerColors.moving}
              />
              <span>PTU Moving</span>
            </div>
            <div className={styles.legendContainer}>
              <MarkerBadge
                glyph={LuCodesandbox}
                shape="pin"
                size={24}
                color={markerColors.stationary}
              />
              <span>PTU Stopped</span>
            </div>
            <div className={styles.legendContainer}>
              <MarkerBadge glyph={LuCodesandbox} shape="pin" size={24} color={lostColor} />
              <span>PTU Lost Contact</span>
            </div>

            <div className={styles.legendContainer}>
              <LuMapPin size={24} color={SEARCH_MARKER_COLOR} />
              <span>Location Marker</span>
            </div>
            <div className={styles.legendContainer}>
              <MarkerBadge glyph={LuBolt} size={24} color={GEO_FEATURE_MARKER_COLOR} />
              <span>Geofence</span>
            </div>
            <div className={styles.legendContainer}>
              <MarkerBadge glyph={LuTriangleAlert} size={24} color={HIGH_RISK_MARKER_COLOR} />
              <span>High Risk Area</span>
            </div>
            <div className={styles.legendContainer}>
              <LuLocate color={GEO_FEATURE_MARKER_COLOR} size={24} strokeWidth={1.6} />
              <span>Geofence Crosshair</span>
            </div>
          </div>
        </div>
      )}
    </MapEmbedding>
  )
}
